import { render, staticRenderFns } from "./ListActiveDetail2.vue?vue&type=template&id=35c421a9&scoped=true&"
import script from "./ListActiveDetail2.vue?vue&type=script&lang=js&"
export * from "./ListActiveDetail2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c421a9",
  null
  
)

export default component.exports